const buildLabelBlock = (product, isLast) => `
  <div class="barcode-container" style="${isLast ? '' : 'page-break-after: always;'}">
    <img src="${product.barcodeImageUrl}" alt="Barcode" crossorigin="anonymous" />
    <div class="product-info">
      <div class="product-name">${product.name}</div>
      <div class="product-details">
        <div>Barcode: ${product.barcode}</div>
        <div>Batch: ${product.batchNo}</div>
        <div>Price: $${product.price}</div>
      </div>
    </div>
  </div>
`;

const PRINT_STYLES = `
  body { margin: 0; padding: 20px; }
  .barcode-container { text-align: center; padding: 20px; border: 2px solid #000; width: 150mm; margin: 0 auto 20px; }
  img { width: 100%; max-width: 150mm; height: auto; }
  .product-info { margin-top: 20px; font-family: Arial, sans-serif; }
  .product-name { font-size: 18px; font-weight: bold; margin-bottom: 10px; }
  .product-details { font-size: 14px; color: #666; }
  @media print { body { padding: 0; } .barcode-container { margin-bottom: 0; border-width: 2px; } .no-print { display: none; } }
`;

const openPrintWindow = (title, bodyHtml) => {
  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>${PRINT_STYLES}</style>
      </head>
      <body>
        ${bodyHtml}
        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 500);
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};

export const printBarcode = (product) => {
  if (!product.barcodeImageUrl) {
    alert('Barcode image not available for this product');
    return;
  }
  openPrintWindow(`Print Barcode - ${product.name}`, buildLabelBlock(product, true));
};

// Bulk version — one print window holding all N labels, each on its own
// page (page-break-after) so the browser's print dialog handles the whole
// batch as one job instead of N separate popups/dialogs.
export const printBarcodes = (products) => {
  const printable = products.filter((p) => p.barcodeImageUrl);
  if (!printable.length) {
    alert('None of the selected products have a barcode image available.');
    return;
  }
  const body = printable.map((p, i) => buildLabelBlock(p, i === printable.length - 1)).join('\n');
  openPrintWindow(`Print ${printable.length} Barcodes`, body);
};
